(function () {
  'use strict';

  var input = document.getElementById('collection-search-input');
  if (!input) return;

  var clearBtn = document.getElementById('collection-search-clear');
  var allProducts = [];
  var originalGridHTML = null;
  var originalPaginationHTML = null;
  var statusEl = null;
  var debounceTimer = null;
  var isSearchActive = false;

  // ── Helpers ────────────────────────────────────────────────────────────────

  function debounce(fn, ms) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fn, ms);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(priceStr) {
    var n = parseFloat(priceStr);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function resizeImage(src, size) {
    if (!src) return '';
    return src
      .split('?')[0]
      .replace(/(\.[^.]+)$/, '_' + size + 'x$1')
      + (src.includes('?') ? '?' + src.split('?')[1] : '');
  }

  /**
   * Returns a relevance score for a product against the query.
   * Matching is TITLE-ONLY so unrelated products never appear.
   * Hyphens are normalized to spaces so "roll-up" matches "roll up".
   *
   *  0 = title starts with query  → top of list
   *  1 = title contains query     → below starters
   * -1 = no match                 → excluded
   */
  function rankProduct(product, query) {
    // Normalize: lowercase + collapse hyphens to spaces so
    // "roll up" matches "roll-up" and vice versa
    var q     = query.toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
    var title = (product.title || '').toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ').trim();

    if (title.startsWith(q)) return 0;
    if (title.includes(q))   return 1;
    return -1;
  }

  // ── Fetch all collection products ─────────────────────────────────────────

  async function loadAllProducts() {
    var page = 1;
    var collected = [];
    while (true) {
      try {
        var res = await fetch('/collections/safety-signs/products.json?limit=250&page=' + page);
        if (!res.ok) break;
        var data = await res.json();
        if (!data.products || data.products.length === 0) break;
        collected = collected.concat(data.products);
        if (data.products.length < 250) break;
        page++;
      } catch (e) {
        break;
      }
    }
    return collected;
  }

  // ── Build a product card matching the theme's existing card structure ──────

  function buildCard(product) {
    var variant = product.variants && product.variants[0];
    var price = variant ? formatMoney(variant.price) : '';
    var comparePrice = variant && variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)
      ? formatMoney(variant.compare_at_price)
      : null;

    var img = product.images && product.images[0];
    var imgSrc = img ? resizeImage(img.src, 460) : '';
    var imgAlt = escHtml(product.title);

    var productUrl = '/products/' + product.handle;

    var priceHtml = '';
    if (price) {
      priceHtml = '<div class="price">';
      if (comparePrice) {
        priceHtml += '<span class="price__regular"><s class="price-item price-item--regular theme-money">' + comparePrice + '</s></span>';
        priceHtml += '<span class="price__sale theme-money">' + price + '</span>';
      } else {
        priceHtml += '<span class="price__regular theme-money">' + price + '</span>';
      }
      priceHtml += '</div>';
    }

    var imgHtml = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + imgAlt + '" class="img-fit card__main-image" loading="lazy" width="460" height="460">'
      : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5" class="media__placeholder img-fit"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20 8.5 8.5 21.3-21.3 29.3 29.3-5.7 5.7-23.6-23.6-21.3 21.3-8.5-8.5-14.6 14.6-5.6-5.7zm82.5-26.5c-4.6 0-8.3-3.7-8.3-8.3s3.7-8.3 8.3-8.3 8.3 3.7 8.3 8.3-3.7 8.3-8.3 8.3z"/></svg>';

    return '<li class="js-pagination-result cs-injected-card">'
      + '<product-card class="card card--product h-full flex">'
      + '<div class="card__media relative">'
      + '<a href="' + productUrl + '" aria-label="' + imgAlt + '" class="media block relative js-prod-link" style="padding-top:100%;" tabindex="-1">'
      + imgHtml
      + '</a>'
      + '</div>'
      + '<div class="card__info-container flex flex-col flex-auto relative">'
      + '<div class="card__info w-full">'
      + '<div class="card__info-inner inline-block w-full">'
      + '<p class="card__title font-bold mb-1">'
      + '<a href="' + productUrl + '" class="card-link text-current js-prod-link">' + escHtml(product.title) + '</a>'
      + '</p>'
      + priceHtml
      + '</div>'
      + '</div>'
      + '</div>'
      + '</product-card>'
      + '</li>';
  }

  // ── DOM helpers ────────────────────────────────────────────────────────────

  function getProductGrid() {
    return document.querySelector('#filter-results ul[role="list"]');
  }

  function getPaginationEl() {
    return document.querySelector('#filter-results .js-pagination-pages, #filter-results nav[aria-label]');
  }

  function getOrCreateStatusEl() {
    if (!statusEl) {
      statusEl = document.createElement('p');
      statusEl.id = 'cs-search-status';
      statusEl.className = 'cs-search-status';
      statusEl.hidden = true;
      var resultsArea = document.getElementById('filter-results');
      if (resultsArea) {
        resultsArea.insertBefore(statusEl, resultsArea.firstChild);
      }
    }
    return statusEl;
  }

  function showStatus(msg) {
    var el = getOrCreateStatusEl();
    el.textContent = msg;
    el.hidden = false;
  }

  function hideStatus() {
    var el = getOrCreateStatusEl();
    if (el) el.hidden = true;
  }

  // ── Grid update ────────────────────────────────────────────────────────────

  function saveOriginalGrid() {
    if (originalGridHTML !== null) return;
    var grid = getProductGrid();
    if (grid) originalGridHTML = grid.innerHTML;
    var pg = getPaginationEl();
    if (pg) {
      originalPaginationHTML = { el: pg, html: pg.outerHTML };
    }
  }

  function restoreOriginalGrid() {
    var grid = getProductGrid();
    if (grid && originalGridHTML !== null) {
      grid.innerHTML = originalGridHTML;
    }
    if (originalPaginationHTML) {
      originalPaginationHTML.el.hidden = false;
    }
    hideStatus();
    isSearchActive = false;
  }

  function renderFilteredGrid(products, query) {
    var grid = getProductGrid();
    if (!grid) return;

    var pg = getPaginationEl();
    if (pg) pg.hidden = true;

    if (products.length === 0) {
      grid.innerHTML = '<li class="col-span-full cs-no-results">'
        + '<p>No products found for <strong>&ldquo;' + escHtml(query) + '&rdquo;</strong> in this collection.</p>'
        + '</li>';
      hideStatus();
    } else {
      grid.innerHTML = products.map(buildCard).join('');
      showStatus('Showing ' + products.length + ' result' + (products.length === 1 ? '' : 's') + ' for \u201c' + query + '\u201d');
    }

    isSearchActive = true;
  }

  // ── Search logic ───────────────────────────────────────────────────────────

  function runSearch(query) {
    if (query.length < 1) {
      restoreOriginalGrid();
      return;
    }

    // Score every product — discard score -1 (no title match)
    var scored = [];
    for (var i = 0; i < allProducts.length; i++) {
      var score = rankProduct(allProducts[i], query);
      if (score !== -1) {
        scored.push({ product: allProducts[i], score: score });
      }
    }

    // Sort: score 0 (starts-with) before score 1 (contains)
    scored.sort(function (a, b) { return a.score - b.score; });

    var matches = scored.map(function (s) { return s.product; });
    renderFilteredGrid(matches, query);
  }

  // ── Init ───────────────────────────────────────────────────────────────────

  loadAllProducts().then(function (products) {
    allProducts = products;
  });

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearBtn.hidden = !query;
    saveOriginalGrid();
    debounce(function () {
      runSearch(query);
    }, 220);
  });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    restoreOriginalGrid();
    input.focus();
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      input.value = '';
      clearBtn.hidden = true;
      restoreOriginalGrid();
      input.blur();
    }
  });
})();